export enum PackageCodeEnum {
    PALLET = 'PALLET',
     BOX = 'BOX',
     BUNDLE = 'BUNDLE',
     CARTON = 'CARTON',
     CRATE = 'CRATE',
     DRUM = 'DRUM',
     ROLL = 'ROLL',
     CASE = 'CASE',
     SKID = 'SKID',
     COIL = 'COIL',
     TUBE = 'TUBE',
     PIPE = 'PIPE',
     BAG = 'BAG',
     PAIL = 'PAIL',
     REEL = 'REEL',
     CYLINDER = 'CYLINDER',
     TOTES = 'TOTES',
     UNITS = 'UNITS'
}
